import React from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'formik'

import { styled } from '@material-ui/core/styles'

import { SubmitButton } from '@ /amazon'

import { Button } from 'components'

const Root = styled('div')({
  display: 'flex',
  flexDirection: 'row',
})

const style = ({ theme }) => ({
  'box-shadow': 'none !important',
  [theme.breakpoints.down('xs')]: {
    width: '100%',
  },
})
const StyledButton = styled(Button)(style)

const StyledSubmitButton = styled(SubmitButton)(style)

const PreviousButton = connect(
  ({ back, children, formik: { values }, ...props }) => {
    return (
      <StyledButton size="large" onClick={() => back(values)} {...props}>
        {children}
      </StyledButton>
    )
  },
)

const FormBottomButtons = ({
  back,
  noPrevious,
  send,
  isSubmitting,
  submit,
  fkey,
  sendLabel,
  ...props
}) => {
  const { t } = useTranslation()

  return (
    <Root {...props}>
      {!noPrevious && (
        /* we set id for tracking purposes */
        <PreviousButton back={back} id={`${fkey}-prev`} disabled={isSubmitting}>
          {t('buttons:previous')}
        </PreviousButton>
      )}
      <StyledSubmitButton
        label={
          sendLabel ? sendLabel : send ? t('buttons:send') : t('buttons:next')
        }
        submit={submit}
        isSubmitting={isSubmitting}
        fkey={fkey}
      />
    </Root>
  )
}

FormBottomButtons.defaultProps = {
  isSubmitting: false,
}

export default FormBottomButtons
